export default __webpack_public_path__ + "static/fwamainbanner_trimmed-80146fe740d3b87d045307b6fa21c690.mp4";